import { render } from "./FamilyRelationDetail.vue?vue&type=template&id=6ff5c58e"
import script from "./FamilyRelationDetail.vue?vue&type=script&lang=js"
export * from "./FamilyRelationDetail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./FamilyRelationDetail.vue?vue&type=style&index=0&id=6ff5c58e&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__